import axios from 'axios';

export const fetchVisitReports = projectId => axios.get(`/projects/${projectId}/reports`);

export default {
  fetchVisitReports
};
